module.exports = __webpack_public_path__ + "sx.a78f81b03f4e326936a9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sx.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sx.svg
// module chunks = styles